import React, { useContext, useMemo } from "react";
import { ArrowLeft, ArrowRight, Person, Schedule, SupervisorAccount } from "@mui/icons-material";
import { DocumentDetailContext } from "../../contexts/DocumentDetailContext";
import * as c from "../../../../utils/constants/constants";
import { LinearProgress } from "@mui/material";
const EpicInformation = (props) => {

    const { _baseClassName, data = {}, docSplit } = useContext(DocumentDetailContext);

    return <div className={`${_baseClassName}-epic-info`}>
        <div className="epic-info-column">
            <div className="epic-info-column-label">Location</div>
            <div className="epic-info-column-value">{data?.location || ""}</div>
        </div>
        <div className="epic-info-column">
            <div className="epic-info-column-label">Status</div>
            <div className="epic-info-column-value" style={{
                color: c.STATUS_COLORS[data?.Status] || "#828282"
            }}>{data?.Status || ""}</div>
        </div>
        {!docSplit?.isDocSplitEnabled && data?.patient_match_in_EMR != true && !data?.MRN && <div className="epic-info-column">
            <div className="epic-info-column-label">Patient Match</div>
            <div className="epic-info-column-value">{data?.Confidence_Level == 0 ? "Not found in EHR" : (data?.Confidence_Level == 50 ? "Multiple patients found in EHR" : (data?.patient_match_in_EMR || ""))}</div>
        </div>}
        {!docSplit?.isDocSplitEnabled && (data.MRN && data.patient_match_in_EMR === true) && <div className="epic-info-column">
            <div className="epic-info-column-label">Patient MRN</div>
            <div className="epic-info-column-value">{data?.MRN || ""}</div>
        </div>}
        {!docSplit?.isDocSplitEnabled && (data.MRN && data.patient_match_in_EMR === true) && <div className="epic-info-column" style={{}}>
            <div className="epic-info-column-label">
                <span>DOB: </span>
                <span className="epic-info-column-value">{data?.matched_patient_dob || ""}</span>
            </div>
            <div className="epic-info-column-label">
                <span>Name: </span>
                <span className="epic-info-column-value">{data?.matched_patient_name || ""}</span>
            </div>
        </div>}
        {docSplit?.isDocSplitEnabled && <div className="epic-info-column">
            <div className="epic-info-column-label">Progress</div>
            <div className="only-flex" style={{ marginTop: "unset", textAlign: "left", marginTop: "-7px"  }}>
                <p className="label-font-flex" style={{ textAlign: "right", margin: "unset" }}>
                    <p style={{ margin: "unset", marginBottom: "2px", fontSize: "0.8rem" }}>{docSplit?.splitProgressPercentage + "%"}</p>
                    <LinearProgress
                        value={docSplit?.splitProgressPercentage}
                        variant="determinate"
                        sx={{
                            width: "100px",
                            backgroundColor: "#ccc",
                            height: "5px",
                            "> span": {
                                backgroundColor: "var(--hti-magenta)"
                            }
                        }} />
                </p>
            </div>
        </div>}
    </div>
}

export default EpicInformation;